<template>
  <div class="mly-product-container">
    <div class="product-content-container">
      <div class="product-introduce">
        <div class="introduce-left">
          <div class="name wow fadeInLeft" data-wow-delay="0.1s">
            <span>玛莉亚U+</span>
          </div>
          <div class="introduce wow fadeInLeft" data-wow-delay="0.2s">
            <span
              >妇产医疗服务销售一体化工具，依托于大流量平台，实现引流到变现的快速转化。玛莉亚U+集医疗行业特色的产品功能，通过大平台流量促成商品服务的销售。并为用户提供配套的便捷小工具，线上咨询，线上预约、线上课堂等。</span
            >
          </div>
          <div class="experience-btn wave wow fadeInLeft" data-wow-delay="0.3s">
            <span>获取体验资格</span>
          </div>
        </div>
        <div class="introduce-right">
          <div class="product-img wow fadeInLeft" data-wow-delay="0.3s">
            <img src="@/assets/images/mly-product.png" alt="" />
          </div>
          <div class="product-bg">
            <img
              class="wow fadeInRight"
              data-wow-delay="0.1s"
              src="@/assets/images/product-bg-2.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="product-advanage">
        <div class="title wow fadeInUp">
          <span>产品优势</span>
        </div>
        <div class="advanage-cards-container">
          <div
            class="advanage-card-container"
            v-for="(item, index) in advanageData"
            :key="index"
          >
            <div
              class="advanage-card wow flipInX"
              :data-wow-delay="`${(index + 1) / 10}s`"
            >
              <img :src="item.imgUrl" alt="" />
            </div>
            <span
              class="wow fadeInUp"
              :data-wow-delay="`${(index + 1) / 10}s`"
              >{{ item.txt }}</span
            >
          </div>
        </div>
      </div>
      <div class="product-function">
        <div class="title wow fadeInUp">
          <span>产品功能</span>
        </div>
        <div class="product-function-cards-container">
          <div class="product-function-card-container">
            <div
              class="product-function-card-img wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <div class="img-container one">
                <img class="pic1" src="@/assets/images/product-10.png" alt="" />
                <img class="card1" src="@/assets/images/card-1.png" alt="" />
                <img class="card2" src="@/assets/images/card-2.png" alt="" />
                <img class="card3" src="@/assets/images/card-3.png" alt="" />
                <img class="card4" src="@/assets/images/card-4.png" alt="" />
              </div>
            </div>
            <div
              class="product-function-card-txt wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div class="index-container">
                <img src="@/assets/images/icon-01.png" alt="" />
              </div>
              <div class="function-title">
                <span>{{ functionData[0].title }}</span>
              </div>
              <div class="function-desc">
                <span v-for="item in functionData[0].desc" :key="item">{{
                  item
                }}</span>
              </div>
            </div>
          </div>

          <div class="product-function-card-container">
            <div
              class="product-function-card-txt wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <div class="index-container">
                <img src="@/assets/images/icon-02.png" alt="" />
              </div>
              <div class="function-title">
                <span>{{ functionData[1].title }}</span>
              </div>
              <div class="function-desc">
                <span v-for="item in functionData[1].desc" :key="item">{{
                  item
                }}</span>
              </div>
            </div>
            <div
              class="product-function-card-img wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div class="img-container even">
                <img class="pic1" src="@/assets/images/product-11.png" alt="" />
                <img class="pic2" src="@/assets/images/product-12.png" alt="" />
              </div>
            </div>
          </div>

          <div class="product-function-card-container">
            <div
              class="product-function-card-img wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <div class="img-container singular">
                <img class="pic2" src="@/assets/images/product-14.png" alt="" />
                <img class="pic1" src="@/assets/images/product-13.png" alt="" />
              </div>
            </div>
            <div
              class="product-function-card-txt wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div class="index-container">
                <img src="@/assets/images/icon-03.png" alt="" />
              </div>
              <div class="function-title">
                <span>{{ functionData[2].title }}</span>
              </div>
              <div class="function-desc">
                <span v-for="item in functionData[2].desc" :key="item">{{
                  item
                }}</span>
              </div>
            </div>
          </div>

          <div class="product-function-card-container">
            <div
              class="product-function-card-txt wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <div class="index-container">
                <img src="@/assets/images/icon-04.png" alt="" />
              </div>
              <div class="function-title">
                <span>{{ functionData[3].title }}</span>
              </div>
              <div class="function-desc">
                <span v-for="item in functionData[3].desc" :key="item">{{
                  item
                }}</span>
              </div>
            </div>
            <div
              class="product-function-card-img wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div class="img-container even">
                <img class="pic1" src="@/assets/images/product-15.png" alt="" />
                <img class="pic2" src="@/assets/images/product-16.png" alt="" />
              </div>
            </div>
          </div>

          <div class="product-function-card-container">
            <div
              class="product-function-card-img wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <div class="img-container singular">
                <img class="pic2" src="@/assets/images/product-18.png" alt="" />
                <img class="pic1" src="@/assets/images/product-17.png" alt="" />
              </div>
            </div>
            <div
              class="product-function-card-txt wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div class="index-container">
                <img src="@/assets/images/icon-05.png" alt="" />
              </div>
              <div class="function-title">
                <span>{{ functionData[4].title }}</span>
              </div>
              <div class="function-desc">
                <span v-for="item in functionData[4].desc" :key="item">{{
                  item
                }}</span>
              </div>
            </div>
          </div>

          <div class="product-function-card-container">
            <div
              class="product-function-card-txt wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <div class="index-container">
                <img src="@/assets/images/icon-06.png" alt="" />
              </div>
              <div class="function-title">
                <span>{{ functionData[5].title }}</span>
              </div>
              <div class="function-desc">
                <span v-for="item in functionData[5].desc" :key="item">{{
                  item
                }}</span>
              </div>
            </div>
            <div
              class="product-function-card-img wow fadeInRight"
              data-wow-delay="0.2s"
            >
              <div class="img-container even">
                <img class="pic1" src="@/assets/images/product-19.png" alt="" />
                <img class="pic2" src="@/assets/images/product-20.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      advanageData: [
        {
          imgUrl: require("@/assets/images/ad-6.png"),
          txt: "专业销售平台",
        },
        {
          imgUrl: require("@/assets/images/ad-7.png"),
          txt: "直播营销工具",
        },
        {
          imgUrl: require("@/assets/images/ad-8.png"),
          txt: "服务配套工具",
        },
        {
          imgUrl: require("@/assets/images/ad-9.png"),
          txt: "线上医疗咨询",
        },
        {
          imgUrl: require("@/assets/images/ad-10.png"),
          txt: "CRM平台数据同步",
        },
      ],
      functionData: [
        {
          id: 1,
          title: "服务内容引流",
          desc: [
            "工具入口：在线问医、明医直播、快速预约、预产计算",
            "商品推荐：依托大数据，优惠推荐、产科专场、妇科专场",
            "卡券推荐：优惠服务直达入口，流量快速变现",
          ],
        },
        {
          id: 2,
          title: "名医在线问诊咨询",
          desc: [
            "专业妇产科医生提供在线咨询服务。多领域专家入住。引导客户了解病症、应对病症、并提供自助的预约服务。全流程一体化自助服务，保证客户隐私",
          ],
        },
        {
          id: 3,
          title: "商城+服务",
          desc: [
            "线上服务+商品结合，客户可根据自身需求在线上下单服务需求，到院后扫码核实即可。除去繁琐的选套餐，支付等流程。订单加密留存，客户更加安心",
          ],
        },
        {
          id: 4,
          title: "名医直播课堂",
          desc: [
            "拥有丰富类目的直播课堂。为客户提供不同阶段的专业知识普及。在直播间客户和专家可进行互动，实时获得住专业的妇产解答。同时关联商品和服务，有针对性的进行营销，实现有效的流量变现",
          ],
        },
        {
          id: 5,
          title: "服务+商券",
          desc: [
            "服务商券：产后、产科、妇科、私密、月子",
            "代金券：线上线下服务促销，为服务提供有效化的营销",
            "体验券：为客户提供低价的服务体验资格",
            "活动专区：帮助服务获得更多的销量",
            "品牌合作：品牌合作服务，与品牌的 联名推广活动",
          ],
        },
        {
          id: 6,
          title: "便捷工具",
          desc: [
            "预产计算：为孕妈生产日期提供参考",
            "预约挂号：自主预约服务，便捷完成线上预约",
          ],
        },
      ],
    };
  },
  mounted() {
    new this.$wow.WOW({
      mobile: false,
      live: false,
    }).init();
  },
};
</script>

<style lang="scss" scoped>
.mly-product-container {
  .product-content-container {
    .product-introduce {
      width: 100%;
      height: 360px;
      background: #f9fafc;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10%;
      .introduce-left {
        flex: 1;
        .name {
          font-family: PingFangSC-Semibold;
          font-size: 34px;
          color: #222222;
        }
        .introduce {
          //   width: 500px;
          padding-right: 10%;
          margin: 20px 0 30px 0;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #6a717c;
          letter-spacing: 0;
        }
        .experience-btn {
          width: 136px;
          height: 40px;
          background-image: linear-gradient(270deg, #119dfd 0%, #0764fb 100%);
          border-radius: 20px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #ffffff;
          @include btn;
        }
      }
      .introduce-right {
        flex: 1;
        height: 100%;
        position: relative;
        display: flex;
        // align-items: center;
        justify-content: center;
        .product-img {
          z-index: 2;
          position: absolute;
          bottom: 0;
          img {
            // height: 260px;
            width: 200px;
          }
        }
        .product-bg {
          position: absolute;
          transform: translate(0, 12px);
          img {
            height: 300px;
          }
        }
      }
    }
    .product-advanage {
      display: flex;
      // justify-content: center;
      flex-direction: column;
      align-items: center;
      .title {
        font-family: PingFangSC-Semibold;
        font-size: 30px;
        color: #222222;
        margin: 70px 0 50px 0;
      }
      .advanage-cards-container {
        width: 100%;
        padding: 0 15%;
        display: flex;
        justify-content: space-between;
        .advanage-card-container {
          .advanage-card {
            width: 120px;
            height: 120px;
            img {
              width: 120px;
              height: 120px;
              margin-bottom: 12px;
            }
          }
          span {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #1e1f28;
          }
        }
      }
    }
    .product-function {
      display: flex;
      // justify-content: center;
      flex-direction: column;
      align-items: center;
      .title {
        font-family: PingFangSC-Semibold;
        font-size: 30px;
        color: #222222;
        margin: 100px 0 50px 0;
      }
      .product-function-cards-container {
        width: 100%;
        .product-function-card-container {
          padding: 0 10%;
          display: flex;
          align-items: center;
          height: 600px;
          background-image: linear-gradient(180deg, #ffffff 0%, #f9fafc 100%);
          .product-function-card-img {
            flex: 1;
            height: 100%;
            display: flex;
            // align-items: flex-end;
            justify-content: center;
            .img-container {
              //   width: 700px;
              position: relative;
              display: flex;
              justify-content: center;
              align-items: flex-end;
            }
            .one {
              img.pic1 {
                width: 300px;
                z-index: 1;
              }
              img.card1 {
                position: absolute;
                height: 80px;
                transform: translate(-135px, -415px);
              }
              img.card2 {
                position: absolute;
                height: 70px;
                transform: translate(185px, -285px);
              }
              img.card3 {
                position: absolute;
                height: 60px;
                transform: translate(-140px, -50px);
                z-index: 2;
              }
              img.card4 {
                position: absolute;
                height: 60px;
                transform: translate(200px, -100px);
              }
            }
            .even {
              margin-right: 10%;
              img.pic1 {
                width: 300px;
                z-index: 1;
              }
              img.pic2 {
                width: 250px;
                position: absolute;
                transform: translate(190px);
              }
            }
            .singular {
              margin-left: 10%;
              img.pic1 {
                width: 300px;
                z-index: 1;
              }
              img.pic2 {
                width: 250px;
                position: absolute;
                transform: translate(-190px);
              }
            }
            // .four {
            //   img.pic1 {
            //     width: 300px;
            //     z-index: 1;
            //   }
            //   img.pic2 {
            //     width: 250px;
            //     position: absolute;
            //     transform: translate(190px);
            //   }
            // }
            // .five {
            //   img.pic1 {
            //     width: 300px;
            //     z-index: 1;
            //   }
            //   img.pic2 {
            //     width: 250px;
            //     position: absolute;
            //     transform: translate(-190px);
            //   }
            // }
            // .six {
            //     margin-right: 100px;
            //   img.pic1 {
            //     width: 300px;
            //     z-index: 1;
            //   }
            //   img.pic2 {
            //     width: 250px;
            //     position: absolute;
            //     transform: translate(190px);
            //   }
            // }
          }

          .product-function-card-txt {
            flex: 1;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .index-container {
              width: 400px;
              img {
                width: 104px;
                height: 74px;
              }
            }
            .function-title {
              position: relative;
              font-family: PingFangSC-Semibold;
              font-size: 30px;
              color: #1e1f28;
              margin-bottom: 20px;
              width: 400px;
              &::after {
                content: "";
                display: block;
                width: 60px;
                height: 4px;
                position: absolute;
                bottom: -20px;
                background-image: linear-gradient(
                  269deg,
                  #baa5ff 0%,
                  #8162e9 100%
                );
              }
            }
            .function-desc {
              margin-top: 37px;
              width: 400px;
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #404040;
              line-height: 28px;
              span {
                display: block;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/productCenter/components/mlyProduct.vue